import { render, staticRenderFns } from "./PrimaryEmailField.vue?vue&type=template&id=ec78eb68&"
import script from "./PrimaryEmailField.vue?vue&type=script&lang=js&"
export * from "./PrimaryEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports